import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const ScrollTop = () => {
    const [backToTop, setBackToTop] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                setBackToTop(true);
            } else {
                setBackToTop(false);
            }
        });
    }, []);

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <div className='topbtn'>
            {backToTop && (
                <FontAwesomeIcon
                    icon={faArrowUp}
                    onClick={scrollUp}
                    style={{
                        position: 'fixed',
                        bottom: "50px",
                        right: "20px",
                        height: "35px",
                        width: "35px",
                        cursor: "pointer",
                        background:"white",
                        color:"black",
                        borderRadius:"5px"
                    }}
                />
            )}
        </div>
    );
};

export default ScrollTop;
